<template>
  <div class="animated fadeIn mt-3" id="report">
    <b-row>
      <b-col>
        <h1 class="text-uppercase font-weight-bold">{{ $route.meta.label }}</h1>
      </b-col>
      <!-- <b-col>
        <div>
          <b-form>
            <b-row>
              <b-col>
                <label for="monthSelect">Mes</label>
                <b-form-select
                  id="monthSelect"
                  v-model="selected.month"
                  :plain="true"
                  :options="selectOptions.months"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="yearSelect">Año</label>
                <b-form-select
                  id="yearSelect"
                  v-model="selected.year"
                  :plain="true"
                  :options="selectOptions.years"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-col> -->
    </b-row>
    <server-table
      :downloadeable="false"
      :column_display="column_display"
      :columns="columns"
      :filterable="filterable"
      :headings="headings"
      :listColumns="listColumns"
      :table-options="tableOptions"
      :url="url"
      @on-loading="loading = $event"
      :action-buttons="action_buttons"
      @on-arrow-right-action="(e) => debug(e)"
    >
      <template slot="precio_unitario" slot-scope="props">
        {{ props.row.precio_unitario | currency }}
      </template>

      <template slot="factura.numero" slot-scope="props">
        {{ props.row.factura.numero }}
      </template>

      <template slot="factura.fecha" slot-scope="props">
        {{ props.row.factura.fecha }}
      </template>

      <template slot="factura.moneda" slot-scope="props">
        {{ props.row.factura.moneda }}
      </template>

      <template slot="factura.proveedor.company_name" slot-scope="props">
        <a
          :href="companyAdminUrl(props.row.factura.proveedor.id)"
          target="_blank"
          :id="'tooltip-company-' + props.row.id"
          >{{ props.row.factura.proveedor.company_name | truncate(20) }}
          <i class="fa fa-external-link"></i>
        </a>
        <b-tooltip :target="'tooltip-company-' + props.row.id" triggers="hover">
          {{ props.row.factura.proveedor.company_name }}
        </b-tooltip>
      </template>

      <template slot="factura.proveedor.company_number" slot-scope="props">
        {{ props.row.factura.proveedor.company_number }}
      </template>

      <template slot="item_costo.asignable_a" slot-scope="props">
        {{ props.row.item_costo.asignable_a }}
      </template>

      <template slot="descripcion" slot-scope="props">
        <span :id="'tooltip-desc-' + props.row.id">
          {{ props.row.descripcion | truncate(30) }}
        </span>
        <b-tooltip :target="'tooltip-desc-' + props.row.id" triggers="hover">
          {{ props.row.descripcion }}
        </b-tooltip>
      </template>

      <template slot="item_costo.nombre" slot-scope="props">
        {{ props.row.item_costo.nombre }}
      </template>
    </server-table>
  </div>
</template>
<script>
import ServerTable from "../../bagno_views/ServerFilterableTable.vue";
var d = new Date();

export default {
  name: "Liquidaciones",
  components: {
    ServerTable
  },
  filters: {
    currency: function (value) {
      // Internationalization of currency
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(value);
    },
    truncate: function (text, stop, clamp) {
      return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
    }
  },
  data() {
    return {
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        products: [],
        product_types: [],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      loading: false,
      action_buttons: ["arrow-right"],
      columns: [
        "factura.proveedor.company_name",
        "factura.proveedor.company_number",
        "factura.numero",
        "factura.fecha",
        "descripcion",
        "cantidad",
        "unidad",
        "precio_unitario",
        "factura.moneda",
        "item_costo.nombre",
        "item_costo.asignable_a"
      ],
      filterable: [
        "factura.proveedor.company_name",
        "factura.proveedor.company_number",
        "factura.numero",
        "factura.fecha",
        "descripcion",
        "cantidad",
        "unidad",
        "precio_unitario",
        "factura.moneda",
        "item_costo.nombre",
        "item_costo.asignable_a"
      ],
      headings: {},
      listColumns: {},
      tableOptions: {
        skin: "table table-sm table-striped table-hover ",
        columnsDisplay: {
          // mobile (x < 480)
          // mobileP (x < 320)
          // mobileL (320 <= x < 480)
          // tablet (480 <= x < 1024)
          // tabletP (480 <= x < 768)
          // tabletL (768 <= x < 1024)
          // desktop (1024 <= x < 1280)
          // desktopLarge (1280 <= x < 1920)
          // desktopHuge (x >= 1920)
          // All options can be preceded by the logical operators min,max, and not followed by an underscore.
          // For example, a column which is set to not_mobile will be shown when
          // the width of the window is greater than or equal to 480px,
          // while a column set to max_tabletP will only be shown when the width is under 768px

          factura: "desktop"
        },
        columnsClasses: {
          factura: "text-left",
          liquidation__date: "text-center"
        },
        headings: {
          "factura.proveedor.company_name": "Proveedor",
          "factura.proveedor.company_number": "RUT",
          "factura.numero": "N° Factura",
          "factura.fecha": "Fecha Factura",
          descripcion: "Descripción",
          cantidad: "Cantidad",
          unidad: "Unidad",
          precio_unitario: "Precio Unitario",
          "factura.moneda": "Moneda",
          "item_costo.nombre": "Item Costo",
          "item_costo.asignable_a": "Asignable a"
        },
        perPage: 10
      }
    };
  },
  computed: {
    url() {
      const params = "?expand=factura.proveedor,item_costo&omit=factura.proveedor.client_company_set";
      return "/costos/detallefactura/" + params;
      //  + "&month=" + this.selected.month + "&year=" + this.selected.year;
    },
    baseUrlAdmin() {
      return localStorage.getItem("packapp_api_url") + "/admin";
    }
  },
  methods: {
    debug(e) {
      console.log(e);
    },
    companyAdminUrl(id) {
      return this.baseUrlAdmin + `/production/company/${id}/change/`;
    }
  },
  mounted() {
    for (let ano = 2017; ano <= d.getFullYear(); ano++) {
      this.selectOptions.years.push({ value: ano, text: ano });
    }
  }
};
</script>
<style></style>
